module.exports = __webpack_public_path__ + "img/signin.3623b5ab.png";